"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _merchant = require("@/api/merchant");
var _device = require("@/api/iot/device");
var _deviceType = require("@/api/iot/deviceType");
var _status = require("@/api/iot/status");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _editDialog = _interopRequireDefault(require("./dialog/editDialog"));
var _treasurerOperator = _interopRequireDefault(require("./dialog/treasurerOperator"));
var _editBatteryBunker = _interopRequireDefault(require("./dialog/editBatteryBunker"));
var _default = {
  components: {
    customPage: _customPage.default,
    editDialog: _editDialog.default,
    treasurerOperator: _treasurerOperator.default,
    editBatteryBunker: _editBatteryBunker.default
  },
  data: function data() {
    return {
      loading: false,
      searchForm: {
        merchant_id: '',
        branch_name: '',
        terminal_no: '',
        name: '',
        status: '',
        is_online: ''
      },
      total: 0,
      tableData: [],
      deviceTypeList: [],
      deviceStatusList: [],
      onlineStatusList: [],
      editItem: null,
      merchantList: [],
      showSimCid: false
    };
  },
  mounted: function mounted() {
    if (this.sMerchantId == 0) {
      this.getMerchantList();
    }
    this.getDeviceTypeList();
    this.getDeviceStatusList();
    this.getOnlieStatusList();
    var query = this.$route.query;
    this.searchForm.branch_name = query.branchName;
    this.getList();
  },
  methods: {
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  this.merchantList = res.data;
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    getDeviceTypeList: function () {
      var _getDeviceTypeList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _deviceType.deviceTypeList)();
              case 2:
                res = _context2.sent;
                if (res) {
                  this.deviceTypeList = res;
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getDeviceTypeList() {
        return _getDeviceTypeList.apply(this, arguments);
      }
      return getDeviceTypeList;
    }(),
    getDeviceStatusList: function getDeviceStatusList() {
      var _this = this;
      (0, _status.getDeviceStatusList)().then(function (res) {
        // console.log('getDeviceStatusList', res)
        if (res) {
          _this.deviceStatusList = res || [];
        }
      });
    },
    getOnlieStatusList: function getOnlieStatusList() {
      var _this2 = this;
      (0, _status.getOnlieStatusList)().then(function (res) {
        // console.log('getOnlieStatusList', res)
        if (res) {
          _this2.onlineStatusList = res || [];
        }
      });
    },
    getList: function getList(flag) {
      var _this3 = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      if (!flag) {
        this.loading = true;
        this.tableData = [];
      }
      (0, _device.cabinetGetList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this3.loading = false;
        _this3.tableData = res.data || [];
        _this3.total = res.total;
      });
    },
    // 编辑
    openEditDialog: function openEditDialog(item) {
      this.editItem = item || null;
      this.$refs.editDialog.dialogVisible = true;
    },
    // 调拨运营商
    openTreasurerOperator: function openTreasurerOperator(item) {
      this.editItem = item || null;
      this.$refs.treasurerOperator.dialogVisible = true;
    },
    // 修改电池仓
    openEditBatteryBunker: function openEditBatteryBunker(item) {
      this.editItem = item || null;
      this.$refs.editBatteryBunker.dialogVisible = true;
    },
    // 跳转电池仓
    jumpBatteryBunker: function jumpBatteryBunker() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$router.push({
        name: 'chkgBatteryBunker',
        query: {
          terminal_no: item.terminal_no
        }
      });
    },
    // 风扇开关
    cabinetFan: function cabinetFan(item) {
      var _this4 = this;
      var on = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var param = {
        terminal_no: item.terminal_no,
        on: on
      };
      (0, _device.cabinetFan)(param).then(function (res) {
        setTimeout(function () {
          _this4.getList(true);
        }, 1000 * 10);
      });
    },
    // 查询换电柜电表度数
    queryMeter: function queryMeter(item) {
      var _this5 = this;
      var title = '电表更新';
      this.$confirm("\u60A8\u786E\u5B9A\u8981\u6267\u884C ".concat(title, " \u64CD\u4F5C\u5417?"), title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        var param = {
          terminal_no: item.terminal_no
        };
        (0, _device.queryMeter)(param).then(function (res) {
          setTimeout(function () {
            _this5.getList(true);
          }, 1000 * 10);
        });
      }).catch(function () {});
    },
    // 查询换电柜sim卡cid
    querySimCid: function querySimCid(item) {
      var _this6 = this;
      var title = '查询换电柜sim卡';
      var content = '';
      if (item.sim_cid) {
        content = "\u5F53\u524D sim_cid: ".concat(item.sim_cid, "<br/>");
        this.showSimCid = true;
      }
      this.$confirm("".concat(content, "\u60A8\u786E\u5B9A\u8981\u6267\u884C ").concat(title, " \u64CD\u4F5C\u5417?"), title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true
      }).then(function () {
        var param = {
          terminal_no: item.terminal_no
        };
        (0, _device.querySimCid)(param).then(function (res) {
          _this6.showSimCid = true;
          setTimeout(function () {
            _this6.getList(true);
          }, 1000 * 10);
        });
      }).catch(function () {});
    },
    // 删除
    removeItem: function removeItem(item) {
      var _this7 = this;
      this.$confirm('您确定要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _device.deviceDel)({
          id: item.id
        }).then(function (res) {
          _this7.getList(true);
        });
      }).catch(function () {});
    },
    // 批量操作
    handleCommand: function handleCommand(command) {},
    // 查询
    search: function search() {
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      this.searchForm = this.$options.data().searchForm;
      this.getList();
    },
    // 重置
    clearMqttTagCache: function clearMqttTagCache() {
      this.$confirm('确认有新增或者修改mqtt链接服务器吗?', '删除mqtt地址缓存', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _device.delMqttTagCache)().then(function (res) {});
      }).catch(function () {});
    }
  }
};
exports.default = _default;